import * as React from "react";
import type { SVGProps } from "react";
const SvgHealthAndSafety = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#health-and-safety_svg__a)">
      <path d="M12 16c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1" />
      <path d="M16 12H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M12 22c-.17 0-.34-.04-.49-.13-.12-.06-2.83-1.58-4.21-2.74-2.61-2.2-4.28-5.38-4.3-8.12V7.5c0-1.23.01-2.45 0-3.49 0-.42.25-.79.64-.94 1.65-.63 4.63-1.02 8.2-1.07 3.32-.04 6.66.37 8.51 1.06.39.14.65.52.65.93v7c.02 3.28-2.11 6.31-4.12 8.04-1.42 1.22-4.29 2.78-4.41 2.85q-.225.12-.48.12zM5.01 4.73V11c.01 2.15 1.44 4.79 3.55 6.57.94.79 2.63 1.81 3.46 2.29.85-.48 2.62-1.52 3.52-2.29 2.14-1.85 3.48-4.41 3.47-6.55V4.75c-1.52-.42-4.11-.77-7.14-.73-2.8.03-5.33.31-6.86.72z" />
    </g>
    <defs>
      <clipPath id="health-and-safety_svg__a">
        <path fill="#fff" d="M3 2h18.01v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHealthAndSafety;
